import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../actions/authActions';

export default function Header() {
  const { user } = useSelector((s) => s.auth);
  const dispatch = useDispatch();
  const role = user?.role;
  const isOps = ['cleaner', 'dispatcher', 'manager', 'admin'].includes(role);
  const isOffice = ['dispatcher', 'manager', 'admin'].includes(role);
  const isManager = ['manager', 'admin'].includes(role);

  return (
    <header className="app-header">
      <Link to="/" className="logo"><img src="/logo-mark.svg" alt="" width="20" height="26" className="logo-mark" />Squeakky<span> Ops</span></Link>
      <nav className="nav">
        {isOps && <NavLink to="/ops/bookings">Bookings</NavLink>}
        {isOffice && <NavLink to="/ops/quotes">Quotes</NavLink>}
        {isOffice && <NavLink to="/ops/teams">Teams</NavLink>}
        {isManager && <NavLink to="/ops/services">Services</NavLink>}
        {isOffice && <NavLink to="/ops/reviews">Reviews</NavLink>}
        {isManager && <NavLink to="/ops/coverage">Coverage</NavLink>}
        {isManager && <NavLink to="/admin">Admin</NavLink>}
      </nav>
      <div className="auth-cluster">
        {user ? (
          <>
            <Link to="/profile" className="hello">{user.name || user.email} <em>{role}</em></Link>
            <button className="btn-ghost" onClick={() => dispatch(logout())}>Sign out</button>
          </>
        ) : (
          <Link to="/login" className="btn-primary">Sign in</Link>
        )}
      </div>
    </header>
  );
}
